import { compose, withHandlers, withState, lifecycle } from 'recompose';
import config from '../../../config';
import { withSpinnerOnAjax } from '../../Common/Spinner';
import { showErrorMsg } from '../../Common/ErrorMsg';

const listReminderApi = (pageNumber = 1) => $.get(`${config.localeApi}/reminders?&page=${pageNumber}`)
  .fail((resp) => {
    const {
      errors = '',
    } = resp.responseJSON;
    showErrorMsg(errors);
  });


const withReminderListData = compose(
  withState('remindersList', 'setRemindersList', []),
  withState('currentPage', 'setCurrentPage', 1),
  withState('lastPage', 'setLastPage', 1),
  withSpinnerOnAjax('getReminderList', listReminderApi),
  withHandlers({
    getListByPage: ({ getReminderList, setRemindersList, setCurrentPage, setLastPage }) => pageNumber => {
      window.scrollTo({ top: 0, right: 0, behavior: 'smooth' });
      getReminderList(pageNumber)
      .done(response => {
        setRemindersList(response.data.data);
        setCurrentPage(response.data.current_page);
        setLastPage(response.data.last_page);
      })
    }
  }),
  lifecycle({
    componentDidUpdate() {
      this.shouldCallApi = window.location.pathname.includes('remind-me');
      if(this.shouldCallApi && !this.didCallApi) {
        this.didCallApi = true;
        this.props.getListByPage(1);
      }
    }
  }),
);

export default withReminderListData;


// WEBPACK FOOTER //
// ./src/Account/RemindMe/withReminderListData.js